module.exports = __webpack_public_path__ + "img/pauli-y-root-34.f6a1da28.svg";